import { createMuiTheme, withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';


export const customThemeRadio = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiFormControlLabel: {
      labelPlacementStart: {
        flexDirection: 'unset',
        marginLeft: '-14px',
        marginRight: '16px',
      },
    },
    MuiFormGroup: {
      root: {
        flexDirection: 'unset',
      },
    },
  },
});

export const GreenRadio = withStyles({
  root: {
    color: 'var(--stick)',
    '&$checked': {
      color: 'var(--stick)',
    },
    padding: '2px 12px',
  },
  checked: {},
})((props) => <Radio color="default" className='radio-green-custom' {...props} />);
